export const electricityData = {
  utilityType: "electricity",
  pageColor: "#584e93",
  profile: {
    firstName: "Samuel",
    lastName: "Balogun",
    phoneNumber: "07023456789",
    estate: "Emerald Estate, Lagos",
    imageUrl: "",
  },
  dashboard: {
    creditCard: {
      name: "Samuel Balogun",
      greeting: "Good Morning",
      meterNumber: "4536251723738",
      installationDate: "23 January, 2021",
    },
    meterReading: {
      postValue: "234.57",
      currentValue: "123.02",
      differenceUsed: "111.55",
    },
    rate: {
      startDate: "01-12-2021",
      endDate: "15-12-2021",
      consumption: "100KWh",
      rate: "22",
      unit: "/KWh",
    },
    lineChart: {
      monthlyData: [0, 10, 5, 15, 20, 25, 45, 20, 30],
      weeklyData: [0, 10, 5, 12, 30, 30, 35, 40, 20],
      yearlyData: [30, 10, 17, 22, 32, 20, 45, 50, 10],
    },
    expenses: {
      total: { tag: "Total(KWh)", amount: "373KWh" },
      totalExpenses: { tag: "Total Expenses", amount: "37KWh Lower" },
      cost: { tag: "Cost", amount: "#1000" },
      pieChartData: {
        yearTwentyNineteen: [300, 150],
        yearTwenty: [350, 100],
        yearTwentyOne: [250, 300],
        backgroundColor: ["#E76F51", "#584e93"],
      },
    },
    payment: {
      fullName: "Samuel Balogun",
      imageUrl: "",
      lastPayment: "01-12-2021",
      meterReading: "435678491213",
      total: "245Kwh",
      totalCost: "#5000",
    },
  },
  usage: {
    consumption: "450.97KWh",
    amountPaid: "NGN52,600",
  },
};

export const waterData = {
  utilityType: "water",
  pageColor: "#2a9d8f",
  profile: {
    firstName: "Samuel",
    lastName: "Balogun",
    phoneNumber: "07023456789",
    estate: "Emerald Estate, Lagos",
    imageUrl: "",
  },
  dashboard: {
    creditCard: {
      name: "Samuel Balogun",
      greeting: "Good Morning",
      meterNumber: "4536251723738",
      installationDate: "23 January, 2021",
    },
    meterReading: {
      postValue: "545.57",
      currentValue: "123.02",
      differenceUsed: "422.55",
    },
    rate: {
      startDate: "01-10-2021",
      endDate: "31-11-2021",
      consumption: "1,355 Liters",
      rate: "1,355",
      unit: "/Liter",
    },
    lineChart: {
      monthlyData: [10, 2, 5, 2, 20, 30, 45, 20, 30],
      weeklyData: [0, 10, 5, 12, 30, 30, 35, 40, 20],
      yearlyData: [0, 10, 10, 22, 30, 30, 45, 50, 45],
    },
    expenses: {
      total: { tag: "Total(Liters)", amount: "377Liters" },
      totalExpenses: { tag: "Total Expenses", amount: "37Liters Lower" },
      cost: { tag: "Cost", amount: "#1600" },
      pieChartData: {
        yearTwentyNineteen: [150, 100],
        yearTwenty: [300, 120],
        yearTwentyOne: [80, 320],
        backgroundColor: [
          "#2a9d8f",
          // "#f2f2f2",
          "#ff8600"
        ],
      },
    },
    payment: {
      fullName: "Samuel Balogun",
      imageUrl: "",
      lastPayment: "01-12-2021",
      meterReading: "435678491213",
      total: "245Liters",
      totalCost: "#5000",
    },
  },
  usage: {
    consumption: "300.25Liters",
    amountPaid: "NGN42,500",
  },
};

export const gasData = {
  utilityType: "gas",
  pageColor: "#E76F51",
  profile: {
    firstName: "Samuel",
    lastName: "Balogun",
    phoneNumber: "07023456789",
    estate: "Emerald Estate, Lagos",
    imageUrl: "",
  },
  dashboard: {
    creditCard: {
      name: "Samuel Balogun",
      greeting: "Good Morning",
      meterNumber: "2336273723739",
      installationDate: "23 January, 2021",
    },
    meterReading: {
      postValue: "444.57",
      currentValue: "100.02",
      differenceUsed: "344.55",
    },
    rate: {
      startDate: "01-10-2021",
      endDate: "31-11-2021",
      consumption: "11,355 Kg",
      rate: "1,355",
      unit: "/kg",
    },
    lineChart: {
      monthlyData: [0, 10, 5, 2, 20, 30, 45, 20, 30],
      weeklyData: [20, 10, 5, 12, 30, 30, 35, 40, 30],
      yearlyData: [30, 10, 10, 22, 30, 30, 45, 50, 10],
    },
    expenses: {
      total: { tag: "Total(Kg)", amount: "373Kg" },
      totalExpenses: { tag: "Total Expenses", amount: "37Kg Lower" },
      cost: { tag: "Cost", amount: "#1000" },
      pieChartData: {
        yearTwentyNineteen: [100, 350],
        yearTwenty: [250, 250],
        yearTwentyOne: [150, 330],
        backgroundColor: ["#2a9d8f", "#E76F51"],
      },
    },
    payment: {
      fullName: "Samuel Balogun",
      imageUrl: "",
      lastPayment: "01-12-2021",
      meterReading: "435678491213",
      total: "25kg",
      totalCost: "#25000",
    },
  },
  usage: {
    consumption: "30.25Kg",
    amountPaid: "NGN33,500",
  },
};
